module.exports = __webpack_public_path__ + "media/images/Loader-9381a5e032454a77b5e20f67dde1b0c2.gif";